import { AppState } from 'app/store';

export const getGlobalSearchLink = (state: AppState) =>
  state.auth.services?.['global-search']?._links?.globalSearch;

export const getIsGlobalSearchOpen = (state: AppState) =>
  state.globalSearch.search !== '' || !!state.globalSearch.searchByCollaborator;

export const getSearchValue = (state: AppState) => state.globalSearch.search;

export const getGlobalSearchResults = (state: AppState) =>
  state.globalSearch.results;

export const getGlobalSearchByCollaborator = (state: AppState) =>
  state.globalSearch.searchByCollaborator;

export const getGlobalSearchLoading = (state: AppState) =>
  state.globalSearch.globalSearchLoading;

export const getNextSearchLink = (state: AppState) =>
  state.globalSearch?._links?.next;
